import type { GameRules } from '@urbanrats/contracts';
import { useI18n, type MessageKey } from '../i18n/index.ts';
import type { RoundOutcome } from '../useGame.ts';

/** Last results of this game: counts for count games, the winning selection otherwise. */
export function RecentResults({ recent, rules }: { recent: RoundOutcome[]; rules: GameRules }) {
  const { t } = useI18n();
  return (
    <section className="recent" aria-label={t('recent.title')}>
      <h2>{t('recent.title')}</h2>
      {recent.length === 0 ? (
        <p className="muted">{t('recent.empty')}</p>
      ) : (
        <ol className="recent-list" data-testid="recent">
          {recent.map((o) => {
            if (o.kind === 'VOIDED')
              return (
                <li key={o.gameRoundId} className="r-void" title={o.gameRoundId}>
                  ∅
                </li>
              );
            const win = o.winning.find((w) => w !== 'EXACT_LOW' && w !== 'EXACT_HIGH') ?? o.winning[0] ?? '';
            const cls = rules.kind === 'COUNT_BANDS' ? `r-${win.toLowerCase()}` : 'r-range';
            return (
              <li key={o.gameRoundId} className={cls} title={`${o.gameRoundId}: ${o.winning.join(', ')}`}>
                {rules.kind === 'COUNT_BANDS' || rules.kind === 'COUNT_BUCKETS' ? <span className="tabular">{o.finalCount}</span> : <span>{t(`sel.${win}` as MessageKey)}</span>}
              </li>
            );
          })}
        </ol>
      )}
    </section>
  );
}
